import type { PurchaseOrderFormValues } from "@/features/purchase/schema";
import { emptyPurchaseOrderForm } from "@/features/purchase/schema";

const PREFIX = "fs-po-form-draft:";

export function poFormDraftKey(mode: "create" | "edit", poId?: string) {
  return mode === "edit" && poId ? `${PREFIX}edit:${poId}` : `${PREFIX}new`;
}

export function loadPoFormDraft(key: string): PurchaseOrderFormValues | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PurchaseOrderFormValues;
    if (!parsed || typeof parsed !== "object" || !Array.isArray(parsed.lines)) return null;
    return {
      ...emptyPurchaseOrderForm,
      ...parsed,
      lines: parsed.lines.length > 0 ? parsed.lines : [emptyPurchaseOrderForm.lines[0]],
    };
  } catch {
    return null;
  }
}

export function savePoFormDraft(key: string, values: PurchaseOrderFormValues) {
  try {
    sessionStorage.setItem(key, JSON.stringify(values));
  } catch {
    /* quota / private mode */
  }
}

export function clearPoFormDraft(key: string) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** True when the draft has user-entered content worth restoring. */
export function isMeaningfulPoDraft(values: PurchaseOrderFormValues | null | undefined) {
  if (!values) return false;
  if (values.vendor_id) return true;
  if ((values.notes ?? "").trim() || (values.terms ?? "").trim()) return true;
  return (values.lines ?? []).some(
    (l) =>
      Boolean(l.material_id) ||
      Number(l.qty) > 0 ||
      Number(l.weight) > 0 ||
      Number(l.unit_rate) > 0 ||
      l.thickness != null ||
      l.width != null ||
      l.length != null ||
      Boolean(l.shape_size_id),
  );
}
